// src/utils/protect.js
// ──────────────────────────────────────────────────────────────────────────
// Light anti-copy DETERRENTS — runs only in production.
//
// ⚠ HONEST NOTE: a website cannot be made un-clonable. Everything the browser
// receives (HTML, CSS, JS, images) can be saved or copied, and any of the
// blocks below can be bypassed by someone determined. These only discourage
// casual copying. Real protection lives on the SERVER: keep valuable data and
// logic behind your authenticated API, watermark assets, and rely on copyright
// / terms of use (already linked in the footer). Treat this as a speed bump.
// ──────────────────────────────────────────────────────────────────────────

export default function enableProtection() {
  if (typeof window === 'undefined') return;
  if (process.env.NODE_ENV !== 'production') return; // don't hinder development

  const block = (e) => { e.preventDefault(); return false; };

  // Right-click context menu
  document.addEventListener('contextmenu', block);

  // Dragging images out of the page
  document.addEventListener('dragstart', (e) => {
    if (e.target && e.target.tagName === 'IMG') block(e);
  });

  // Common "view source / devtools" shortcuts
  document.addEventListener('keydown', (e) => {
    const k = (e.key || '').toLowerCase();
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && ['i', 'j', 'c'].includes(k)) ||
      (e.ctrlKey && k === 'u')
    ) block(e);
  });
}
